module.exports = __webpack_public_path__ + "static/media/bg17.300d495c.jpg";